// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap--JuGzl","head":"head--c1DPz","headBtn":"headBtn--mWfPB","tab":"tab--BkMwO","box":"box--rikQQ","img":"img--cEJ+l","project":"project--KMhml","wrapper":"wrapper--OpLyf"};